import { render } from "./MenuLateralDash.vue?vue&type=template&id=0aa78f66&scoped=true"
import script from "./MenuLateralDash.vue?vue&type=script&lang=js"
export * from "./MenuLateralDash.vue?vue&type=script&lang=js"

import "./MenuLateralDash.vue?vue&type=style&index=0&id=0aa78f66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa78f66"]])

export default __exports__